import { SearchState } from '@/types/store/search';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const state: SearchState = {
  searchCriteria: {
    cabinets: [],
    documentTypes: [],
    anyReference: {
      value: '',
      filterType: null,
      includeFullText: false
    },
    dateRange: null,
    orderBy: { field: 'CB_DOCDATE', isSortingAscending: false },
    standardSearch: null,
    isAdvancedSearch: false,
    advancedSearch: null,
    userId: undefined,
    isFullTextSearch: false,
    fullTextSearchValue: null
  },
  searchResults: {
    selectedItemKeys: [],
    currentPage: 1,
    itemsPerPage: 20,
    showSorting: false,
    showFilters: false,
    appliedFilterOptions: [],
    appliedSortOptions: [],
    columnOrders: [],
    splitConfiguration: 0,
    response: {},
    unsortedItems: [],
    documentId: 0,
    cabinetId: ''
  }
};

const namespaced: boolean = true;

export const search = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
